module.exports = __webpack_public_path__ + "static/img/product_active.addfcb90.svg";